export default __webpack_public_path__ + "static/media/1.caa3d734.png";